import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    ctaContinue: 'Continue',
    description:
      'Make sure you include all the elements on one sheet of paper.',
    title: 'Upload Identity verification (handwritten)',

    uploadFailureMessage:
      'Upload failed. Please check your connection and try again',
    // TODO(matt): Format the bold 'browse' in blue
    uploadFormBrowse: 'or **browse** to choose a file',
    uploadFormDragDrop:
      'Drag and drop to upload your handwritten proof of identification',
  },
  fr: {
    ctaContinue: 'Continuer',
    description:
      'Assurez-vous que tous les éléments figurent sur une seule et même page.',
    title: 'Ajoutez votre attestation d’identité manuscrite',
    uploadFailureMessage:
      'Le téléchargement a échoué. Veuillez vérifier votre connexion et réessayer.',
    uploadFormBrowse:
      'ou **parcourez** vos documents au format PDF, JPG ou PNG',
    uploadFormDragDrop: 'Déposez votre preuve d’identité manuscrite ici',
  },
} as const);

export default locales;
